module.exports = __webpack_public_path__ + "SRT_ready-small.png";